import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Registration = lazy(() => import('../pages/registration/page'));
const VehicleListings = lazy(() => import('../pages/listings/page'));
const VehicleDetail = lazy(() => import('../pages/vehicle-detail/page'));
const SearchFilters = lazy(() => import('../pages/search/page'));
const Comparison = lazy(() => import('../pages/comparison/page'));
const TransactionMessaging = lazy(() => import('../pages/transaction/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/registration',
    element: <Registration />,
  },
  {
    path: '/listings',
    element: <VehicleListings />,
  },
  {
    path: '/vehicle-detail',
    element: <VehicleDetail />,
  },
  {
    path: '/search',
    element: <SearchFilters />,
  },
  {
    path: '/comparison',
    element: <Comparison />,
  },
  {
    path: '/transaction',
    element: <TransactionMessaging />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
